import {injectable} from "inversify";

import SystemConfig, {CONFIG_PARAMS} from "./SystemConfig";
import {mobileAndTabletCheck} from "../device/device";

export const PLATFORM = {
    "MOBILE": "mobile",
    "DESKTOP": "desktop",
    "VLT": "vlt"
};

@injectable()
export default class SystemPlatform {

    private _platform: string;
    private _displayCount: number;

    init(config: SystemConfig) {
        if(config.get(CONFIG_PARAMS.EXHIBITION)) {

            this._platform = PLATFORM.VLT;

        } else if(!mobileAndTabletCheck()) {

            this._platform = PLATFORM.DESKTOP;

        } else {

            this._platform = PLATFORM.MOBILE;

        }

        this._displayCount = Number(config.get(CONFIG_PARAMS.DISPLAYS));
    }

    getPlatform(): string {
        return this._platform;
    }

    isVLT(): boolean {
        return this._platform === PLATFORM.VLT;
    }

    getDisplaysCount(): number {
        return this._displayCount;
    }
}